import React from 'react'
import PropTypes from 'prop-types'

import { ListItem, ListItemText, IconButton, SvgIcon, Typography } from '@mui/material'
import { ReactComponent as ArrowRotateLeftIcon } from 'assets/ArrowRotateLeftIcon.svg'

import { getNoteUserInfo } from 'data/notes/notesSelectors'
import { convertDateTimeToPreferedTimezone } from 'data/dateTime/convertDateTimeToPreferedTimezone'

const ArchiveNoteListItem = ({ note, Icon = ArrowRotateLeftIcon, onClick }) => {
  const { note: noteText } = note
  const { firstName, lastName, dateTime, username } = getNoteUserInfo({ note, isUpdatedByPreference: false })
  const createdFullName = `${firstName} ${lastName}`.trim()
  const createdDisplayName = createdFullName || username || '--'
  const { onlyDate: createdOnlyDate, onlyTime: createdOnlyTime } = convertDateTimeToPreferedTimezone({ dateTime })

  const {
    firstName: updatedFirstName,
    lastName: updatedLastName,
    dateTime: updatedDateTime,
    username: updatedUsername,
  } = getNoteUserInfo({ note })
  const updatedFullName = `${updatedFirstName} ${updatedLastName}`.trim()
  const updatedDisplayName = updatedFullName || updatedUsername || '--'
  const { onlyDate: updatedOnlyDate, onlyTime: updatedOnlyTime } = convertDateTimeToPreferedTimezone({ dateTime: updatedDateTime })

  return (
    <ListItem
      sx={{ pl: 3 }}
      secondaryAction={
        <IconButton onClick={onClick}>
          <SvgIcon>
            <Icon />
          </SvgIcon>
        </IconButton>
      }
    >
      <ListItemText
        primary={noteText}
        secondary={
          <>
            <Typography variant="subtitle2" fontWeight={400}>
              {`Created by ${createdDisplayName} | ${createdOnlyDate} @ ${createdOnlyTime}`}
            </Typography>
            <Typography variant="subtitle2" fontWeight={400}>
              {`Archived by ${updatedDisplayName} | ${updatedOnlyDate} @ ${updatedOnlyTime}`}
            </Typography>
          </>
        }
        slotProps={{
          primary: { variant: 'h6', fontWeight: 400, noWrap: true },
        }}
      />
    </ListItem>
  )
}

ArchiveNoteListItem.propTypes = {
  note: PropTypes.object.isRequired,
  Icon: PropTypes.elementType,
  onClick: PropTypes.func.isRequired,
}

export default ArchiveNoteListItem
